import {
  SEARCH_SDS,
  SEARCH_SDS_ERROR,
  DELETE_ALL,
  DELETE_RECORD,
  SEARCH_SDS_IN_PROGRESS,
} from '../actions/types';

const initialState = {
  sdsSearchResults: [],
  errored: false,
  sdsSearchInProgress: false,
  internalErrored:true,
};

export default function (state, action) {
  state = state || initialState;
  switch (action.type) {
    case SEARCH_SDS_IN_PROGRESS:
      return {
        ...state,
        sdsSearchInProgress: true,
      };
    case SEARCH_SDS:
      return {
        ...state,
        sdsSearchResults: [...action.payload, ...state.sdsSearchResults],
        errored: false,
        sdsSearchInProgress: false,
      };
    case SEARCH_SDS_ERROR:
      return {
        ...state,
        errored: action.payload,
        sdsSearchInProgress: false,
        internalErrored: action.payload,
      };
    case DELETE_RECORD:
      return {
        ...state,
        sdsSearchResults: state.sdsSearchResults.filter(
          (result) => result.id !== action.payload
        ),
        errored: false,
      };
    case DELETE_ALL:
      return {
        ...state,
        sdsSearchResults: [],
        errored: false,
      };
    default:
      return state;
  }
}
